import { FC } from "react";
import "./styles.scss";

interface DotsLoaderProps {
  text?: string;
}

const DotsLoader: FC<DotsLoaderProps> = ({ text }) => {
  return (
    <div className="loader-container">
      <div className="opacity-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default DotsLoader;
